import { render, staticRenderFns } from "./DisplayLive.vue?vue&type=template&id=f869a864&scoped=true&"
import script from "./DisplayLive.vue?vue&type=script&lang=js&"
export * from "./DisplayLive.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLive.vue?vue&type=style&index=0&id=f869a864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f869a864",
  null
  
)

export default component.exports